import { FieldSchema } from "../../../Schema";

/**
 * Which model the record is — "IREquipment" or "IRCluster".
 *
 * Written once when the record is created and never edited. It is here so the record's shape
 * is described in one place: the selection set, the proposed-change diff and the write
 * payloads are all derived from this schema, and an attribute the schema does not know about
 * silently drops out of whichever of those needs it.
 */
export const modelName: FieldSchema = {
  name: "modelName",
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Model name", disabled: true, displayed: false },
};
